export default "__VITE_ASSET__712a8a95__"